import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";

export default function ReportsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/reports").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!data) return <Loader />;

  return (
    <div className="space-y-6" data-testid="admin-reports">
      <h1 className="text-[32px] font-bold text-[#1c1b1b]">Reports</h1>
      <p className="text-sm text-[#434654]">On-screen completion, performance & video analytics · {data.total_nurses} nurses total</p>
      <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-[#fcf9f8] border-b border-[#E5E7EB]">
              {["Module", "Assigned", "Completed", "Avg Score", "Pass Rate", "Attempts", "Avg Watch (min)"].map((h) => (
                <th key={h} className="text-left text-[12px] font-bold uppercase tracking-wider text-[#434654] px-4 py-3">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.modules.map((m) => (
              <tr key={m.module_id} data-testid={`report-row-${m.module_id}`} className="border-b border-[#E5E7EB] last:border-0">
                <td className="px-4 py-3 font-medium text-[#1c1b1b]">{m.title}</td>
                <td className="px-4 py-3 text-sm">{m.assigned}</td>
                <td className="px-4 py-3 text-sm">{m.completed}</td>
                <td className="px-4 py-3 text-sm font-semibold">{m.avg_score}%</td>
                <td className="px-4 py-3 text-sm">{m.pass_rate}%</td>
                <td className="px-4 py-3 text-sm">{m.attempts}</td>
                <td className="px-4 py-3 text-sm">{m.avg_watch_minutes}</td>
              </tr>
            ))}
            {data.modules.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-sm text-[#434654]">No modules to report on.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
